import { CustomFieldGroup } from '@wix/ambassador-wix-quotes-web/types';

export const extractDocumentCustomFields = (customFields) => customFields.filter((filed) => filed.group === CustomFieldGroup.DOCUMENT)
.map((field) => {
  return { displayName: field.displayName, value: field.value.value }
});

export const extractBusinessCustomFields = (customFields) => customFields.filter((field) => field.group === CustomFieldGroup.BUSINESS_DETAILS)
.map((field) => {
  return { displayName: field.displayName, value: field.value.value }
});
